import React from 'react'
import { connect } from 'react-redux'
import { doGetShift, doSaveShift, doDeleteShift } from '../../reducers/actions'

class ShiftDiv extends React.Component {
    state = {}
    componentDidMount = () => {
        const { onClose, dispatch, id } = this.props
        dispatch(doGetShift({
            id,
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else if (initValues基本信息) {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {} })
                }
            }
        }))
    }

    handlerConfirm = () => {
        const { initValues基本信息, changedValues基本信息, id } = this.state
        const { onSave, onClose, dispatch } = this.props
        dispatch(doSaveShift({
            id,
            changedValues基本信息,
            onEnd: ({ errorMessage, message }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    if (message && message != '')
                        Ext.toast('保存成功，' + message)
                    else
                        Ext.toast('保存成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        }))
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose, dispatch } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteShift({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            })))
    }


    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息, id } = this.state
        return Object.keys(changedValues基本信息).length > 0 || id < 0
    }

    fieldset基本信息 = () => {
        return [
            { _text: '班别', minWidth: '95%', },
            { _text: '上午', name: '上午开始', minWidth: '45%', },
            { _text: '~', name: '上午结束', minWidth: '45%', },
            { _text: '下午', name: '下午开始', minWidth: '45%', },
            { _text: '~', name: '下午结束', minWidth: '45%', },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        return <Body data={this} maxWidth="600"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(ShiftDiv)